import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

/**
 * Service for Currencies
 */
@Injectable()
export class CurrencyService {
    constructor(private requestService: ObservableRequestService) { }

    getCurrencies(): Observable<any> {
        const getCurrenciesURL = ConstantsService.CURRENCIES_ENDPOINT;
        return this.requestService.getRequest(getCurrenciesURL);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/currency-service.ts